<script setup lang="ts">
import LegendMenu from "./Settings/LegendMenu.vue";
import ScaleMenu from "./Settings/ScaleMenu.vue";
import DrawerMenuContent from "./DrawerMenuContent.vue";
import LineWeightMenu from "./Settings/LineWeightMenu.vue";
import RegenerateItem from "./Settings/RegenerateItem.vue";
import SettingsOptionItem from "./Settings/SettingsOptionItem.vue";
import SettingsToggleItem from "./Settings/SettingsToggleItem.vue";
import { useWorkSettings } from "@/composable/useWorkSettings";
import { AUTOSAVE_DELAY_MS } from "@/stores/SaveDrawingState";
import { openDisplayDialog } from "@/stores/DisplayDialogState";
import UiChangesBanner from "@/components/canvas/uiChanges/UiChangesBanner.vue";
import { isUiChangesAvailable } from "@/stores/UiChangesState";

const { stylusOnly, autoSave } = useWorkSettings();
</script>

<template>
  <DrawerMenuContent :label="$t('settings')" description="">
    <div class="d-flex flex-column gap-2">
      <!-- Présentation de la nouvelle interface, jusqu'à sa date de fin -->
      <UiChangesBanner v-if="isUiChangesAvailable()" class="mb-1" />
      <div class="canvas-divider-horizontal"></div>
      <LegendMenu />
      <div class="canvas-divider-horizontal"></div>
      <ScaleMenu />
      <div class="canvas-divider-horizontal"></div>
      <!-- Taille de l'interface, poignées, règles, aides : modale Affichage -->
      <SettingsOptionItem
        :title="$t('canvas:display.open.title')"
        :description="$t('canvas:display.open.desc')"
        icon="sliders"
        @click="openDisplayDialog('settings')"
      />
      <div class="canvas-divider-horizontal"></div>
      <!-- Façon de travailler (ex-paramètres généraux de l'app) -->
      <SettingsToggleItem
        v-model="stylusOnly"
        :title="$t('canvas:settings.stylusOnly.title')"
        :description="$t('canvas:settings.stylusOnly.desc')"
      />
      <SettingsToggleItem
        v-model="autoSave"
        :title="$t('canvas:settings.autoSave.title')"
        :description="
          $t('canvas:settings.autoSave.desc', {
            seconds: AUTOSAVE_DELAY_MS / 1000,
          })
        "
        :warning="autoSave ? undefined : $t('canvas:settings.autoSave.offHint')"
      />
      <div class="canvas-divider-horizontal"></div>
      <LineWeightMenu />
      <div class="canvas-divider-horizontal"></div>
      <RegenerateItem />
      <div class="canvas-divider-horizontal"></div>
    </div>
  </DrawerMenuContent>
</template>

<style lang="scss" scoped></style>
